import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const propTypes = {
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  selectedToggle: PropTypes.string,
  toggleValue: PropTypes.string,
};
const defaultProps = {
  onClick: () => {},
  selectedToggle: '',
  toggleValue: '',
};

const Toggle = ({ children, onClick, selectedToggle, toggleValue }) => {
  const classes = cx(
    'col-md-2 col-xs-4 toggle-button text-center',
    {
      clickable: toggleValue !== selectedToggle,
      selected: toggleValue === selectedToggle,
    },
  );

  return (
    <div className={classes} onClick={() => onClick(toggleValue)}>
      {children}
    </div>
  );
};

Toggle.propTypes = propTypes;
Toggle.defaultProps = defaultProps;

export default Toggle;
